import { render, staticRenderFns } from "./ApproveModel.vue?vue&type=template&id=176dec04&scoped=true"
import script from "./ApproveModel.vue?vue&type=script&lang=js"
export * from "./ApproveModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176dec04",
  null
  
)

export default component.exports